import { useState, FormEvent } from 'react';
import { apiRequest } from '../../services/apiService';
// import { apiRequest } from '../../services/apiService';

const TrocaSenha = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('Todos os campos são obrigatórios.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('A nova senha e a confirmação não correspondem.');
      return;
    }

    try {
      setLoading(true);
      await apiRequest('login/trocarsenha', 'POST', true, { senhaAntiga: oldPassword, senhaNova: newPassword, senhaNovaConfirmar: confirmPassword });
      setSuccess('Senha alterada com sucesso!');
      
      // Limpa os campos após o sucesso
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError((err as Error).message || 'Erro ao alterar a senha. Verifique sua senha anterior.');
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center mt-5">
        <div className="col-sm-10 col-md-8 col-lg-6">
          <div className="card">
            <div className="card-body">
              <div className="m-sm-4">
                <div className="text-center mb-4">
                  <h1 className="h2">Alterar Senha</h1>
                  <p className="lead">
                    Mantenha sua conta segura alterando sua senha.
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  {error && <div className="alert alert-danger">{error}</div>}
                  {success && <div className="alert alert-success">{success}</div>}

                  <div className="mb-3">
                    <label className="form-label">Senha Anterior</label>
                    <input className="form-control form-control-lg" type="password" name="oldPassword" placeholder="Digite sua senha anterior" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Nova Senha</label>
                    <input className="form-control form-control-lg" type="password" name="newPassword" placeholder="Digite sua nova senha" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Confirmação de Senha</label>
                    <input className="form-control form-control-lg" type="password" name="confirmPassword" placeholder="Confirme sua nova senha" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                  </div>
                  <div className="text-center mt-3">
                    {loading ?
										<div className="d-flex justify-content-center">
											<div className="spinner-border text-primary" role="status">
												<span className="visually-hidden">Loading...</span>
											</div>
										</div> :
                    <button type="submit" className="btn btn-lg btn-primary">Alterar Senha</button>}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrocaSenha;